export const getTextWidth = (isHeading: boolean, isFullWidth: boolean) => {
  if (isFullWidth) return "100%";

  if (isHeading) {
    return "fit-content";
  }

  return "55%";
};
